module.exports = __webpack_public_path__ + "img/login_client.fa55b6e8.svg";